import { Badge } from "@theg1group/ui";
import { severityTone } from "../lib/format.ts";

/** Severity (critical/high/medium/low) or a 0..100 risk score → coloured pill. */
export function RiskBadge({
	severity,
	score,
}: {
	severity?: string | null;
	score?: number | null;
}) {
	if (severity) return <Badge variant={severityTone(severity)}>{severity}</Badge>;
	if (score === null || score === undefined) return <span className="text-muted">—</span>;
	const sev = score >= 80 ? "critical" : score >= 60 ? "high" : score >= 30 ? "medium" : "low";
	return (
		<Badge variant={severityTone(sev)}>
			{sev} · {Math.round(score)}
		</Badge>
	);
}
